/**
 * Mapping for the toggle button depending on states.
 *
 * @type {Object}
 * @public
 */
export const BLOCK = 'block';
export const NONE = 'none';
export const DIRECTIONS = {
  [BLOCK]: 'up',
  [NONE]: 'down'
};

/**
 * Type to icon mapping. Can be extended with more types if needed.
 *
 * @type {Object}
 * @public
 */
export const ICONS = {
  offer: 'uxicon-star',
  success: 'uxicon-ok',
  info: 'uxicon-information',
  warning: 'uxicon-alert',
  danger: 'uxicon-alert',
  note: 'uxicon-help',
  c3: 'uxicon-comment'
};



// WEBPACK FOOTER //
// ./node_modules/@ux/alert/constants.js